<!-- eslint-disable -->
<template>
    <li style="background: whitesmoke;border-radius: 4px;">
        <template v-if="item.C_门店类型=='分组'">
            <template v-if="getMdlist(item.list).length>0">
                <div style="display:flex;align-items: center;padding: 20px 10px;" @click="$set(item, 'hideMx', !item.hideMx && item.list.length > 1)">
                    <div style="font-weight: bolder;" @click.stop="onClick(item)">
                        <el-checkbox v-if="checkbox" v-model="item.checked" :indeterminate="item.indeterminate" @change="e=>on分组选择(item,e)"></el-checkbox>
                        <small style="font-weight: initial;">({{ item.I_门店Id }})</small>
                        {{ item.C_门店名称 || '' }}
                    </div>
                    <div style="flex:1;"></div>
                    <i class="el-icon-arrow-down" :class="item.hideMx ? 'rotate0' : 'rotate180'"></i>
                </div>
                <el-collapse-transition>
                    <ul style="padding-left:40px;" class="fgx" v-show="!item.hideMx">
                        <template v-for="(item2, index2) in getMdlist(item.list)">
                            <groupOrMD :item="item2" :key="index2" :checkbox="checkbox"  :门店过滤str="门店过滤str" @click="e=>onGroupOrMDClick(e)" @change="e=>onchange(item,e)"></groupOrMD>
                        </template>
                    </ul>
                </el-collapse-transition>
            </template>
        </template>
        <template v-else>
            <div style="padding:20px 10px;display:flex;align-items: center;background: white;" @click.stop="onClick(item)">
                <div style="flex:1;">
                    <el-checkbox v-if="checkbox" v-model="item.checked" @change="e=>on门店选择(item,e)"></el-checkbox>
                    ({{ item.I_门店Id }}) {{ item.C_门店名称 }}
                </div>
                <div v-if="item.C_同步结果" style="font-size:12px;color:red;">{{item.C_同步结果}}</div>
                <i class="el-icon-arrow-right"></i>
            </div>
        </template>
    </li>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => { }
        },
        门店过滤str: {
            type: String,
            default: ''
        },
        checkbox: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getMdlist(list) {
            let tmplist = list;
            tmplist = tmplist.Where(a => {
                if ((a.C_门店类型 || '门店') != '门店') return true;
                if (a.C_门店名称.includes(this.门店过滤str) || a.I_门店Id.toString().includes(this.门店过滤str)) return true;
                if (this.getMdlist(a.list || []).length > 0) return;
                return false;
            });
            return tmplist;
        },
        onClick(e) {
            this.$emit('click', e);
        },
        onGroupOrMDClick(e) {
            this.$emit('click', e);
        },
        on分组选择(item, checked) {
            console.log('触发1',checked)
            item.list.forEach(e => {
                e.checked = checked;
                // this.$nextTick(() => {
                //     this.$set(e, 'checked', checked);
                // });
                this.$forceUpdate()
                if (e.list && e.list.length > 0) {
                    this.on分组选择(e, checked);
                }
            });
            item.indeterminate = !(item.list.Where(a => a.checked).length == item.list.length) && item.list.Where(a => a.checked).length > 0;
            console.log(`分组选择item.indeterminate`, item.indeterminate);
            this.$emit('change', checked);
        },
        on门店选择(item, checked) {
            item.checked = checked;
            
            // this.$nextTick(() => {
            //     this.$set(item, 'checked', checked);
            // });
            this.$forceUpdate()
            this.$emit('change', checked);
        },
        onchange(item, checked) {
            item.indeterminate = !(item.list.Where(a => a.checked).length == item.list.length) && item.list.Where(a => a.checked).length > 0;
            if (item.list.length > 0) {
                item.checked = item.list.Where(a => a.checked).length == item.list.length;
            }

            console.log(`item.indeterminate`, item, item.indeterminate);


            this.$emit('change', checked);
        },
    }
}
</script>

<style>
</style>